import type { LucideIcon } from 'lucide-react';

import React from 'react';

import { ImportCard } from './ImportCard';

export interface StatTile {
  testId: string;
  Icon: LucideIcon;
  value: number | string;
  label: string;
}

/** A row of equal-width count tiles, each with a tinted icon over its number. */
export function StatTiles({ tiles }: { tiles: StatTile[] }) {
  return (
    <div className="grid grid-cols-3 gap-3">
      {tiles.map(tile => (
        <ImportCard
          key={tile.testId}
          className="flex flex-col items-center gap-1.5 px-2 py-3 text-center"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-50 dark:bg-primary-500/10">
            <tile.Icon
              className="h-[18px] w-[18px] text-primary-500"
              aria-hidden
            />
          </span>
          <span
            data-testid={tile.testId}
            className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white"
          >
            {tile.value}
          </span>
          <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
            {tile.label}
          </span>
        </ImportCard>
      ))}
    </div>
  );
}
